import { Module, VuexModule } from 'vuex-module-decorators';
import NotificationItemModel from '@/modules/notifications/models/notification-item.model';

@Module
export default class NotificationStore extends VuexModule {
    activeItems: NotificationItemModel[] = [];
    historyItems: NotificationItemModel[] = [];
}
